import type { IconData } from '@stacksjs/iconify-core'

export const backgroundColor: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m7.543 8l.506 1.386c.17.466.734.722 1.26.57c.525-.15.813-.651.643-1.117l-2.05-5.61c-.197-.542-.675-.967-1.285-1.142c-1.05-.302-2.179.209-2.52 1.141L2.05 8.838c-.17.467.118.967.643 1.119c.525.15 1.09-.105 1.26-.571L4.458 8zm-.73-2H5.188L6 3.776zM2 0h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default backgroundColor
